import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { actionGetNotifications, actionDeleteNotification, actionSaveNotification, actionGetUsersNotified } from "../actions/NotificationActions"
  import { LOGIN_ROUTE, NOTIFICATIONS_ADD_ROUTE, NOTIFICATIONS_EDIT_ROUTE } from "../config/RoutesConstants"
import { 
  Container, 
  IconButton,
  Button,
  Box, 
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Paper,
  Typography, 
  Fab,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  TextField,
  Tooltip,
  Input,
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import BlockIcon from '@material-ui/icons/Block';
import ActiveIcon from '@material-ui/icons/CheckCircle';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import RefreshIcon from '@material-ui/icons/Sync';
import UsersNotified from '@material-ui/icons/Group';
import Util, { SUCCESS,ERROR } from '../common/Util'

class Notifications extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={page:0, rowPerPage:5, count:0, notifications:[], filter:"", 
                notificationForDelete:false, notificationSelected:null, openUsersNotified:null}
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onChangePage=this.onChangePage.bind(this)
    this.onChangeRowsPerPage=this.onChangeRowsPerPage.bind(this)
    this.getDeleteNotificationSuccess=this.getDeleteNotificationSuccess.bind(this)
    this.onConfirmDeleteNotification=this.onConfirmDeleteNotification.bind(this)
    this.onSearch=this.onSearch.bind(this)
    this.onAddNotification=this.onAddNotification.bind(this)
    this.onRefresh=this.onRefresh.bind(this)
    this.renderUsersNotified=this.renderUsersNotified.bind(this)
  }

  componentWillMount(){
    if(this.props.login){
      this.props.actionGetNotifications(this.onChangePage, this.getNotificationsError)
    }
    
  }

  getNotificationsError(e){
    console.log("ERROR GET NOTIFICATIONS", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar las notificaciones.")
  }

  onSearch(evt){
    this.setState({filter:evt.target.value}, this.onChangePage)
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let filter = new RegExp(this.state.filter,"ig")
    let notifications = this.props.notificationList.filter((t)=>{return t.tskParams&&t.tskParams.title&&t.tskParams.title.match(filter)})
    const count = notifications.length
    notifications = notifications.slice(from, end)
    this.setState({page:newPage, count:count, notifications:notifications})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let filter = new RegExp(this.state.filter,"ig")
    let notifications = this.props.notificationList.filter((t)=>{return t.tskParams&&t.tskParams.title&&t.tskParams.title.match(filter)})
    const count = notifications.length
    notifications = notifications.slice(from, end)
    this.setState({rowPerPage:evt.target.value, notifications:notifications})
  }
  
  onRefresh(){
    this.props.actionGetNotifications(this.onChangePage, this.getNotificationsError)
  }

  onAddNotification(){
    this.props.history.push(NOTIFICATIONS_ADD_ROUTE) 
  }


  onEditNotification(notification){
    this.props.history.push(NOTIFICATIONS_EDIT_ROUTE, notification)
    //this.setState({ notificationSelected:notification})
  }
  
  onDeleteNotification(notification){
    this.setState({notificationForDelete:notification})  
  }

  onConfirmDeleteNotification(){
    this.props.actionDeleteNotification(this.state.notificationForDelete,this.getDeleteNotificationSuccess,this.getDeleteNotificationError)
    this.setState({notificationForDelete:false})
  }

  getDeleteNotificationSuccess(){
    this.props.actionGetNotifications(()=>{this.onChangePage(null,this.state.page)}, this.getNotificationsError)
  }

  getDeleteNotificationError(e){
    console.log("ERROR", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al elminar la notificación.")
  }
  
  onUsersNotified(notification){
    this.setState({openUsersNotified:notification.tskUsersNotified||[]})
    // this.props.actionGetUsersNotified(notification.id, (users)=>{
    //   console.log("USERS", users)
      
    // }, (e)=>{Util.showNotify(ERROR,"No pudimos consultar los usuarios notificados")})
  }

  renderUsersNotified(users, filter){
    const {theme}= this.props
    if(users&&users.length>0){
      let reg = new RegExp(filter,"ig")
      return users.filter(u=>u.proName&&u.proName.match(reg)||u.proLastName&&u.proLastName.match(reg)||u.proDNI&&u.proDNI.toString().match(reg))
                  .map((u,index)=>{
          return (<ListItem key={`u${index}`} style={index%2==0?theme.table.row:theme.table.rowColor}>
                    <ListItemText primary={`${u.proName} ${u.proLastName}`} secondary={u.proDNI}/>
                  </ListItem>)
          })
    }
  }

  renderTableHeader(){
    const {theme} = this.props
    const headers = ["Título","Descripción", "Imágen", "Status", "Fecha de ejecución"]
    return (
    <TableRow>
      {headers.map((label)=>{
        return (
          <TableCell>{label}</TableCell>
        )
      })}
      <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme} = this.props
    let notifications = this.state.notifications
    if(!notifications||notifications.length==0){
      return <Box style={theme.table.empty}>No se encontraron registros</Box>
    }
    return notifications.map((item, index)=>{
      let noti = item.tskParams
      let isActive=item.tskStatus&&item.tskStatus.toLowerCase() == "complete"
      let isError=item.tskStatus&&item.tskStatus.toLowerCase() == "error"
      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell>{noti.title}</TableCell>
          <TableCell>{noti.body}</TableCell>
          <TableCell>
             {noti.image?<img
								style={{ height: "85px", objectFit: "contain" }}
								src={noti.image}
								alt=""
							/>:"Sin imagen"}
          </TableCell>
          <TableCell style={isActive?theme.table.activeCell:theme.overrides.MuiTableCell.body}>{isActive?"ENVIADA":isError?"ERROR":"AGENDADA"}</TableCell>
          <TableCell>{Util.formatDateToShow(Util.timestampToMoment(item.tskRunDate))}</TableCell>
          <TableCell style={theme.table.actionsColumn}>
            {item.tskTags&&item.tskTags.length>0&&
              <Tooltip title="Usuarios notificados">
                <IconButton onClick={this.onUsersNotified.bind(this,item)}>
                  <UsersNotified/>
                </IconButton>
              </Tooltip>
            }
            {isActive?null:[
              <Tooltip title="Editar notificación">
                <IconButton onClick={this.onEditNotification.bind(this,item)}>
                  <EditIcon/>
                </IconButton>
              </Tooltip>
              ,
              <Tooltip title="Eliminar notificación">
                <IconButton onClick={this.onDeleteNotification.bind(this, item)}>
                  <DeleteIcon/>
                </IconButton>
              </Tooltip>
            ]}
          </TableCell>
        </TableRow>
      )
    })
  }

  render(){
    const { theme, notificationList } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={theme.title.container}>
          <Typography variant="h1">Notificaciones</Typography>
          <Typography variant="subtitle1">Crea notificaciones</Typography>
        </Box>
        <Container style={theme.table.container}>        
          <Paper>
            <Box style={{display:"flex", alignItems:"center"}}>
              <Typography style={theme.paper.title} variant="h2">Listado de notificaciones</Typography>
              <Fab onClick={this.onRefresh} size="small" style={{marginLeft:16, width:34, height:34}} color="secondary">
                  <RefreshIcon style={{fontSize:20}}/>
                </Fab>
            </Box>
            <Toolbar style={theme.table.toolbar}>
              <Tooltip title="Crear nueva notificación">
                <Fab color="primary" onClick={this.onAddNotification} size="small">
                  <AddIcon />
                </Fab>
              </Tooltip>
              <Box>
                <Input placeholder="Buscar" onChange={this.onSearch}/>
              </Box>
            </Toolbar>
            <Table stickyHeader>
              <TableHead > 
                {this.renderTableHeader()}
              </TableHead>
              <TableBody>
                {this.renderTableBody()}
              </TableBody>
            </Table> 
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.state.count}
              rowsPerPage={this.state.rowPerPage}
              page={this.state.page}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          </Paper>
          <Dialog open={this.state.notificationForDelete}>
            <DialogTitle>Eliminar Notificación</DialogTitle>
            <DialogContent>
              <DialogContentText>¿Está seguro que desea eliminar la notificación?</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Tooltip title="Cancelar">
                <Button variant="contained" color="secondary" onClick={()=>{this.setState({notificationForDelete:null})}}>Cancelar</Button>
              </Tooltip>
              <Tooltip title="Eliminar notificación">  
                <Button variant="contained" color="primary" onClick={this.onConfirmDeleteNotification}>Eliminar</Button>
              </Tooltip>  
            </DialogActions>
          </Dialog>
          <Dialog open={this.state.openUsersNotified?true:false}>
            <DialogTitle>Usuarios Notificados</DialogTitle>
            <DialogContent>
            { this.state.openUsersNotified&&this.state.openUsersNotified.length==0?
              <DialogContentText>No se envió la notificación a ningún usuario</DialogContentText>
            :
            [<TextField label="Buscar" onChange={(evt)=>this.setState({filterUsersNotified:evt.target.value})}/>,
              <List style={{height:200, overflow:"auto"}}>
                  {this.renderUsersNotified(this.state.openUsersNotified,this.state.filterUsersNotified)}
              </List>
            ]
            }
            </DialogContent>
            <DialogActions>
              <Tooltip title="Cerrar">
                <Button variant="contained" color="primary" onClick={()=>{this.setState({openUsersNotified:null})}}>Cerrar</Button>
              </Tooltip>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    notificationList: store.ntf.notificationList||[]
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetNotifications,
      actionDeleteNotification,
      actionSaveNotification,
      actionGetUsersNotified
    },
    dispatch
  );
}

export default  withRouter(
                  withTheme(
                    connect(
                      mapStateToProps,
                      mapDispatchToProps
                    )(Notifications)
                  )
                )


// WEBPACK FOOTER //
// ./src/screens/Notifications.js